import React from "react";
import { MdFileUpload } from "react-icons/md";

interface UploadButtonProps {
  onUpload: () => void;
  isVisible?: boolean;
}

const UploadButton: React.FC<UploadButtonProps> = ({ onUpload, isVisible = true }) => {
  if (!isVisible) return null;

  return (
    <button
      onClick={onUpload}
      className="absolute z-[70] top-4 left-4 flex items-center justify-center w-12 h-12 text-white transition-all duration-200 bg-black rounded-full bg-opacity-70 hover:bg-opacity-90 active:scale-95"
      aria-label="Upload from Gallery"
    >
      <MdFileUpload className="w-6 h-6" />
    </button>
  );
};

export default UploadButton;
